
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default{
data () {
return {
play: false,
loaded: false
}
},
components: {
Loading,
ViewBox,
XHeader
},
mounted () {
this.loaded = true
this.play = true
},
methods: {
}
}



// WEBPACK FOOTER //
// ./src/components/Usdt1.vue